import L from 'leaflet';
import 'leaflet-kml';
import { createLayerComponent } from '@react-leaflet/core';
import kmlUtilities from '../../utilities/kmlUtilities';

const createKmlLayer = (props, context) => {
    const { kml } = props;
    const instance = new L.FeatureGroup();

    const styles = L.KML.parseStyles(kml);
    L.KML.parseStyleMap(kml, styles);

    Array.from(kml.getElementsByTagName('Placemark')).forEach(placemark => {
        const layer = L.KML.parsePlacemark(placemark, kml, styles);

        if (!layer) {
            return;
        }

        layer.off('add');
        layer.on('click', e => {
            if (instance.onFeatureClick) {
                instance.onFeatureClick(kmlUtilities.getPlacemarkInfo(placemark), e.latlng);
            }
        });

        instance.addLayer(layer);
    });

    Array.from(kml.getElementsByTagName('GroundOverlay')).forEach(overlay => {
        const layer = L.KML.parseGroundOverlay(overlay);
        if (layer) {
            instance.addLayer(layer);
        }
    });

    instance.onFeatureClick = props.onFeatureClick;

    if (context.map.options.preferCanvas) {
        setTimeout(map => map._renderer?._update(), 0, context.map);
    }

    return { instance, context };
};

const updateKmlLayer = (instance, props) => {
    instance.onFeatureClick = props.onFeatureClick;
};

const KmlLayer = createLayerComponent(createKmlLayer, updateKmlLayer);

export default KmlLayer;
